import Model from '@/models/Model'
import { numberFormatter } from '../../services/JSUtils'
import printerApi from '../../services/printerApi'

export default class SlSaleTicket extends Model {
    resource() {
        return 'sl_sale_ticket'
    }

    get branchOfficeName() {
        return this.first_pos_sale &&
            this.first_pos_sale.pos_cash_desk &&
            this.first_pos_sale.pos_cash_desk.g_branch_office
            ? this.first_pos_sale.pos_cash_desk.g_branch_office.name
            : null
    }

    get fullBranchOfficeName() {
        return this.first_pos_sale &&
            this.first_pos_sale.pos_cash_desk &&
            this.first_pos_sale.pos_cash_desk.g_branch_office
            ? this.first_pos_sale.pos_cash_desk.g_branch_office.name +
                  ' - ' +
                  this.first_pos_sale.pos_cash_desk.g_branch_office.address
            : null
    }

    get cashDeskNumber() {
        return this.first_pos_sale && this.first_pos_sale.pos_cash_desk
            ? this.first_pos_sale.pos_cash_desk.number
            : null
    }

    get sellerName() {
        return this.first_pos_sale &&
            this.first_pos_sale.g_seller_user &&
            this.first_pos_sale.g_seller_user.hr_employee
            ? this.first_pos_sale.g_seller_user.hr_employee.name_case
            : null
    }

    get cashierName() {
        return this.first_pos_sale &&
            this.first_pos_sale.g_cashier_user &&
            this.first_pos_sale.g_cashier_user.hr_employee
            ? this.first_pos_sale.g_cashier_user.hr_employee.name_case
            : null
    }

    get formattedTotal() {
        return '$' + numberFormatter(parseInt(this.total))
    }

    get formattedRoundingLaw() {
        return this.rounding_law
            ? '$ ' + numberFormatter(parseInt(this.rounding_law))
            : '$ 0'
    }

    get formattedCashChange() {
        return this.cash_change
            ? '$ ' + numberFormatter(parseInt(this.cash_change))
            : '$ 0'
    }

    getByNumber(number) {
        return new Promise((resolve, reject) => {
            this.include(
                'first_pos_sale.g_seller_user.hr_employee',
                'first_pos_sale.g_cashier_user.hr_employee',
                'first_pos_sale.pos_cash_desk.g_branch_office',
                'sl_detail_sale_tickets.wh_product'
            )
                .append('cash_change', 'rounding_law', 'payments')
                .where('exact_number', number)
                .get()
                .then(r => {
                    if (!r.data) throw 'Sin Resultados'
                    resolve(r.data.find(ticket => ticket.number === number))
                })
                .catch(reject)
        })
    }

    printTicketSaleReceiptHtmlByNumber(number, companyData, officeData) {
        console.log(2)
        return new Promise((resolve, reject) => {
            this.getByNumber(number)
                .then(ticket => {
                    resolve(
                        ticket.printTicketSaleReceiptHtml(
                            companyData,
                            officeData
                        )
                    )
                })
                .catch(reject)
        })
    }

    printTicketSaleReceiptHtml(companyData = {}) {
        const {
            business_name,
            commercial_business,
            address,
            rut,
            sii_resolution_month,
            sii_resolution_year,
        } = companyData
        let obj = {
            eSignatureURL: this.signature_url,
            title: business_name,
            resNumber: sii_resolution_month,
            resYear: sii_resolution_year,
            barcode: '',
            subtitle: 'BOLETA ELECTRÓNICA',
            rut,
            billNum: this.number,
            activities: commercial_business,
            address: address,
            office: this.fullBranchOfficeName
                ? this.fullBranchOfficeName.toUpperCase()
                : null,
            seller: this.sellerName,
            cashier: this.cashierName,
            cashDesk: this.cashDeskNumber || null,
            date: this.emission_date,
            time: this.created_at.split(' ')[1],
            subtotal:
                parseInt(this.total) +
                parseInt(this.global_discount_amount || 0),
            total: parseInt(this.total),
            change: this.cash_change,
            roundLaw: this.rounding_law,
            applyRoundLaw: !!this.roundLaw,
            amountPaid:
                this.payments.reduce(
                    (paid, p) => (paid += parseInt(p.amount)),
                    0
                ) + parseInt(this.cash_change),
            discount: parseInt(this.global_discount_percentage || 0),
            amountDiscount: parseFloat(this.global_discount_percentage || 0),
            arrayPayments: this.payments.map(p => ({
                payment:
                    parseInt(p.amount) +
                    (p.pos_sale_payment_type_id === 1
                        ? parseInt(this.cash_change)
                        : 0),
                paymentMethod: p.pos_sale_payment_type_id,
                paymentDetail: {
                    serialNumber: p.serial_number,
                    checkTypeId: !!p.charge_date ? 1 : 2,
                    transNumber: p.transfer_number,
                    creditInstallments: p.pos_customer_credit_option_type,
                    sl_sale_credit_note_id: p.sl_sale_credit_note_number,
                    voucher: p.voucher_number,
                },
            })),
            posSaleType: 1,
            items: this.sl_detail_sale_tickets.map(item => {
                item.price = parseInt(item.price || 0)
                item.total =
                    parseFloat(item.quantity) * parseInt(item.price) -
                    parseInt(item.discount_or_charge_value || 0)
                item.discount_or_charge_value = parseInt(
                    item.discount_or_charge_value || 0
                )
                item.discount_or_charge_percentage = parseInt(
                    item.discount_or_charge_percentage || 0
                )

                return item
            }),
            preventPrint: localStorage.getItem('_prevent_print'),
            isEmployee: false,
        }
        let win = window.open('receip.html')
        Object.assign(win.window, obj)
    }

    printTicketSaleReceiptServiceByNumber(number, companyData = {}) {
        return new Promise((resolve, reject) =>
            this.getByNumber(number)
                .then(r => r.printTicketSaleReceiptService(companyData))
                .then(resolve)
                .catch(reject)
        )
    }

    printTicketSaleReceiptService(companyData = {}) {
        const {
            business_name,
            commercial_business,
            address,
            rut,
            sii_resolution_month,
            sii_resolution_year,
        } = companyData
        // console.log({ companyData })
        const obj = {
            company_name: business_name,
            header_rut: rut,
            header_subtitle: 'BOLETA ELECTRÓNICA',
            header_footer: `Nro: ${this.number}`,
            
            business_title: '',
            business_commercial_business: commercial_business,
            business_address: address,
            business_branch_office: this.fullBranchOfficeName,
            business_phone: '',
            business_seller: this.sellerName,
            business_cashier: this.cashierName,
            business_cash_desk: this.cashDeskNumber,
            business_employee: '',

            sale_date_time: this.created_at,
            detail_product_message: 'DETALLE DE VENTA',
            items: this.sl_detail_sale_tickets.map(item => {
                item.discount_or_charge_percentage = parseInt(
                    item.discount_or_charge_percentage
                )
                item.discount_or_charge_value = parseInt(
                    item.discount_or_charge_value
                )
                return item
            }),
            discount_text: parseInt(this.global_discount_amount)
                ? `Se ha aplicado un descuento global de ${parseInt(
                      this.global_discount_amount
                  )}`
                : '',
            total_subtotal:
                parseInt(this.total) +
                parseInt(this.global_discount_amount || 0),
            total_discount_percentage: parseInt( this.global_discount_percentage || 0),
            total_discount: parseInt(this.global_discount_amount || 0),
            total: parseInt(this.total || 0),
            total_iva: parseInt(parseInt(this.total || 0)*0.19),
            total_rounding_law: this.rounding_law,
            total_to_pay: parseInt(this.total) + parseInt(this.rounding_law),
            sale_paid:
                this.payments.reduce(
                    (paid, payment) => (paid += payment.amount),
                    0
                ) + parseInt(this.cash_change),
            total_cash_change: parseInt(this.cash_change),
            sale_payment_message: 'DETALLE DE PAGOS',
            sale_payments: this.payments.map(p => ({
                payment:
                    parseInt(p.amount) +
                    (p.pos_sale_payment_type_id === 1
                        ? parseInt(this.cash_change)
                        : 0),
                paymentMethod: p.pos_sale_payment_type_id,
                paymentDetail: {
                    serialNumber: p.serial_number,
                    checkTypeId: !!p.charge_date ? 1 : 2,
                    transNumber: p.transfer_number,
                    creditInstallments: p.pos_customer_credit_option_type,
                    sl_sale_credit_note_id: p.sl_sale_credit_note_number,
                    voucher: p.voucher_number,
                },
            })),
            signature_url: this.signature_url,
            // signature_url: '',
            signature_title: 'TIMBRE ELECTRÓNICO SII',
            signature_res: `Res.${sii_resolution_month} de ${sii_resolution_year} Verifique documento: www.sii.cl`,
            footer_text: '',
        }

        let timeout = () =>
            new Promise((resolve, reject) => {
                setTimeout(
                    () => reject('Tiempo de espera agotado'),
                    process.env.VUE_APP_PRINTER_SERVICE_TIMEOUT
                        ? parseInt(process.env.VUE_APP_PRINTER_SERVICE_TIMEOUT)
                        : 8000
                )
            })
        let promise = Promise.race([
            printerApi.printCashDeskReceipt(obj),
            timeout(),
        ])
        return promise
    }

    printTicketSaleReceiptByNumber(
        number,
        companyData,
        isHtml = false,
        useHtmlFallback = true
    ) {
        if (isHtml)
            return this.printTicketSaleReceiptHtmlByNumber(number, companyData)
        else
            return new Promise((resolve, reject) =>
                this.printTicketSaleReceiptServiceByNumber(number, companyData)
                    .then(resolve)
                    .catch(
                        e =>
                            useHtmlFallback
                                ? this.printTicketSaleReceiptHtmlByNumber(
                                      number,
                                      companyData
                                  )
                                : reject(e)
                    )
                    .then(resolve)
                    .catch(reject)
            )
    }
}
